import { CommonModule } from '@angular/common';
import { Component, inject, signal, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { getEntityConfig, type EntityConfig } from '../../config/entity-config';
import { EntityDetailPageComponent } from '../entity-detail/entity-detail-page.component';

/**
 * Route component for /manage/:entityKey/:id. Renders custom detail or default EntityDetailPageComponent.
 */
@Component({
  selector: 'app-management-detail',
  standalone: true,
  imports: [CommonModule, EntityDetailPageComponent],
  template: `
    @if (entityConfig(); as config) {
      @if (config.detailComponent) {
        <ng-container *ngComponentOutlet="config.detailComponent; inputs: { entityConfig: config, id: id() }" />
      } @else {
        <app-entity-detail-page [entityConfig]="config" [id]="id()" />
      }
    } @else {
      <p>Unknown entity.</p>
    }
  `,
})
export class ManagementDetailComponent implements OnInit, OnDestroy {
  private readonly route = inject(ActivatedRoute);
  private sub: Subscription | null = null;
  readonly entityConfig = signal<EntityConfig | undefined>(undefined);
  readonly id = signal('');

  ngOnInit(): void {
    this.sub = this.route.paramMap.subscribe((params) => {
      const key = params.get('entityKey') ?? '';
      this.entityConfig.set(getEntityConfig(key));
      this.id.set(params.get('id') ?? '');
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
